import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../../../Shared/Icons';
import { outageBannerSelectors } from './ducks';
import Cookie from '../../../services/Cookie';
import { OutageBannerWrapper, OutageBannerTextWrapper, OutageBannerHeader, OutageBannerDescription, WarningWrapper, WarningTextWrapper, CloseWrapper, CloseButton, CloseIcon, GrayedArea } from './OutageBanner.styles';

class OutageBanner extends React.Component {
  state = {
    isBannerDismissed: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isBannerDismissed: false,
    };
  }

  dismissBanner = () => {
    const { outageCookieName } = this.props;
    this.setState({ isBannerDismissed: true });
    Cookie.setCookie(outageCookieName, false);
  };

  render() {
    const { isBannerDismissed } = this.state;
    const { bannerHeader, bannerDescription } = this.props;

    return (
      <>
        <OutageBannerWrapper isBannerDismissed={isBannerDismissed}>
          <WarningTextWrapper>
            <WarningWrapper>
              <Icon iconName="warning" />
            </WarningWrapper>
            <OutageBannerTextWrapper>
              <OutageBannerHeader>{bannerHeader}</OutageBannerHeader>
              <OutageBannerDescription>{bannerDescription}</OutageBannerDescription>
            </OutageBannerTextWrapper>
          </WarningTextWrapper>
          <CloseWrapper>
            <CloseButton onClick={this.dismissBanner}>
              <CloseIcon iconName="close" />
            </CloseButton>
          </CloseWrapper>
        </OutageBannerWrapper>
        <GrayedArea isBannerDismissed={isBannerDismissed} onClick={this.dismissBanner} />
      </>
    );
  }
}

OutageBanner.propTypes = {
  bannerHeader: PropTypes.string.isRequired,
  bannerDescription: PropTypes.string.isRequired,
  outageCookieName: PropTypes.string.isRequired
};

OutageBanner.defaultProps = {
  bannerHeader: 'Sorry, we are experiencing an outage',
  bannerDescription: 'Our tech team is working quickly resolve this issue',
  outageCookieName: 'OutageBannerCookie'
};

const mapStateToProps = state => ({
  bannerHeader: outageBannerSelectors.getOutageBannerHeader(state),
  bannerDescription: outageBannerSelectors.getOutageBannerDescription(state),
  outageCookieName: outageBannerSelectors.getOutageCookieName(state)
});

export default connect(
  mapStateToProps
)(OutageBanner);
